import { GLServiceBase, ServiceRoute } from "commonui";
import { IFocusWordsAssociationService } from "./interface";

class FocusWordsAssociationServiceClass extends GLServiceBase<any, any> implements IFocusWordsAssociationService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/focuswords" };

	getFocusWordsByChapterId(params, unitId): Promise<any> {
		return this.get("unit/{unitId}", params, unitId);
	}

	updateFocusWords(params): Promise<any> {
		return this.update("updateFocusWordsAssociation", params);
	}
}

export const FocusWordsAssociationService = () =>
	new FocusWordsAssociationServiceClass() as IFocusWordsAssociationService;
